export  enum RoleType {
    Root = 1,
    ChiefEngineer = 2,
    SeniorEngineer =3,
    SuperAdmin = 4,
    SuperintendEngineer = 5,
    ExecutiveEngineer = 6,
    AssistantExecutiveEngineer = 7,
    AssistantEngineer = 8,
}


